export default {
      id: "ic_spor_toto_delete-usage",
      viewBox: "0 0 16 17",
      url: "/" + "images/icons.3.109.2.svg#ic_spor_toto_delete-usage",
      toString: function () {
        return this.url;
      }
    }